import axios from 'axios';

const INVALID_ADMIN_SESSION_RESPONSES = new Set([
  '401:Not authenticated',
  '401:Invalid admin token',
  // get_admin_user uses these two 403s when the credential is valid JWT but
  // no longer represents an admin identity. Other 403s are action failures.
  '403:Admin access required',
  '403:Admin not found',
]);

export const ADMIN_SESSION_INVALID_EVENT = 'crossedpaths:admin-session-invalid';

export const isInvalidAdminSessionResponse = (error) => (
  INVALID_ADMIN_SESSION_RESPONSES.has(
    `${error?.response?.status}:${error?.response?.data?.detail}`,
  )
);

export const clearAdminSessionForRejectedRequest = (error) => {
  const requestToken = error?.config?.adminSessionToken;
  const currentToken = localStorage.getItem('adminToken');

  // A response from a request made before a new login must never end the new
  // session. The request interceptor captures the exact token it sent.
  if (!requestToken || requestToken !== currentToken || !isInvalidAdminSessionResponse(error)) {
    return false;
  }

  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminUser');
  window.dispatchEvent(new Event(ADMIN_SESSION_INVALID_EVENT));
  return true;
};

// This instance is intentionally imported only by protected admin pages.
// Public and login requests continue to use axios directly.
const adminApi = axios.create();

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (!token) return config;

  config.adminSessionToken = token;
  config.headers = config.headers || {};
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    clearAdminSessionForRejectedRequest(error);
    return Promise.reject(error);
  },
);

export default adminApi;
